import { colors } from "./colors.js";
const sizes = {
  spacing: {
    none: 0,
    "01": 0.125,
    // 2px
    "02": 0.25,
    // 4px
    "03": 0.375,
    // 6px
    "04": 0.5,
    // 8px
    "05": 0.625,
    // 10px
    "06": 0.75,
    // 12px
    "07": 1,
    // 16px
    "08": 1.5,
    // 24px
    "09": 2,
    // 32px
    10: 2.5,
    // 40px
    11: 3,
    // 48px
    12: 3.5,
    // 56px
    13: 4,
    // 64px
    14: 5,
    // 80px
    15: 6
    // 96px
  },
  radius: {
    none: 0,
    xs: 0.125,
    sm: 0.25,
    md: 0.375,
    lg: 0.5,
    xl: 0.75,
    "2xl": 1,
    "3xl": 1.5,
    full: 100
  },
  borderWidth: {
    0: 0,
    1: 0.0625,
    2: 0.125,
    3: 0.1875,
    4: 0.25
  },
  breakpoint: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
  }
};
const font = {
  weight: {
    thin: 100,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  letterSpacing: {
    tighter: -0.05,
    // -0.8px
    tight: -0.03125,
    // -0.5px
    normal: 0,
    // 0px
    wide: 0.01875,
    // 0.3px
    wider: 0.03125,
    // 0.5px
    widest: 0.09375
    // 1.5px
  },
  lineHeight: {
    "leading-3": 0.75,
    // 12px
    "leading-4": 1,
    // 16px
    "leading-5": 1.25,
    // 20px
    "leading-6": 1.5,
    // 24px
    "leading-7": 1.75,
    // 28px
    "leading-8": 2,
    // 32px
    "leading-9": 2.25,
    // 36px
    "leading-10": 2.5,
    // 40px
    "leading-11": 3,
    // 48px
    "leading-12": 4
    // 64px
  },
  family: {
    headline: "Archivo",
    body: "Archivo",
    number: "Archivo"
  },
  size: {
    xs: 0.75,
    // 12px
    sm: 0.875,
    // 14px
    base: 1,
    // 16px
    lg: 1.125,
    // 18px
    xl: 1.25,
    // 20px
    "2xl": 1.5,
    // 24px
    "3xl": 1.875,
    // 30px
    "4xl": 2.25,
    // 36px
    "5xl": 3,
    // 48px
    "6xl": 3.875,
    // 62px
    "7xl": 4.5,
    // 72px
    "8xl": 6,
    // 96px
    "9xl": 8
    // 128px
  },
  style: {
    italic: "italic",
    normal: "normal"
  }
};
const primitives = {
  colors,
  sizes,
  font
};
export {
  colors,
  primitives as default,
  font,
  primitives,
  sizes
};
